export const sheetPaperSx = (theme) => ({
    borderTopLeftRadius: theme.sizes.mobileSheetRadius,
    borderTopRightRadius: theme.sizes.mobileSheetRadius,
    maxHeight: '85vh',
    display: 'flex',
    flexDirection: 'column'
});

export const grabHandleWrapSx = {
    display: 'flex',
    justifyContent: 'center',
    pt: 1.25,
    pb: 0.5,
    flexShrink: 0
};

export const grabHandleSx = {
    width: 40,
    height: 5,
    borderRadius: 3,
    bgcolor: 'border.input'
};

export const headerSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    px: 2.25,
    pt: 0.75,
    pb: 1.75,
    flexShrink: 0
};

export const titleSx = {
    fontSize: 18,
    fontWeight: 800,
    minWidth: 0
};

export const contentSx = {
    px: 2.25,
    pb: 2,
    overflowY: 'auto',
    flex: 1
};

// The sticky action area (the Apply button): stays in view while the content
// above scrolls, and clears the home indicator.
export const footerSx = {
    px: 2.25,
    pt: 1.5,
    pb: 'calc(14px + env(safe-area-inset-bottom))',
    borderTop: 1,
    borderColor: 'divider',
    flexShrink: 0
};
